/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBlob.defs.js'
export * as $defs from './getBlob.defs.js'
